/**
 * /billing → /billing/plans default redirect.
 *
 * Bare `/billing` lands on the hub layout's <Outlet/> with no child route,
 * so we redirect at `beforeLoad` to send users straight to the Plans tab.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/billing/")({
  beforeLoad: () => {
    throw redirect({ to: "/billing/plans" });
  },
});
